import createVueComponent from '../createVueComponent';

const Asterisk = createVueComponent('AsteriskIcon', [
  ['path', { d: 'M12 6v12' }],
  ['path', { d: 'M17.196 9L6.804 15' }],
  ['path', { d: 'M6.804 9l10.392 6' }],
]);

export default Asterisk;
